<template>
  <div v-loading="loading">
    <!-- 搜索条件 -->
    <el-row class="viewKPITitle">
      <el-col style="margin-right:10px;" :span="4">
        <el-input size="small" clearable v-model="searchName" placeholder="请输入员工姓名"></el-input>
      </el-col>
      <el-col :class="pType==0?'show':'hidden'" :span="4">
        <el-date-picker size="small" v-model="dateMonth" type="month" placeholder="选择月"></el-date-picker>
      </el-col>
      <el-col :class="pType==0?'hidden':'show'" :span="4">
        <el-date-picker
            size="small"
            v-model="yearValue"
            type="year"
            placeholder="选择年">
        </el-date-picker>
      </el-col>
      <el-col :class="pType==0?'hidden':'show'" :span="4">
        <el-select v-model="dateJidu" size="small" placeholder="请选择季度">
          <el-option label="Q1" value="Q1"></el-option>
          <el-option label="Q2" value="Q2"></el-option>
          <el-option label="Q3" value="Q3"></el-option>
          <el-option label="Q4" value="Q4"></el-option>
        </el-select>
      </el-col>
      <el-col :span="1">
        <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
      </el-col>
      <el-col :span="1">
        <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
      </el-col>
    </el-row>
    <!-- 头部信息 -->
    <div style="margin-bottom:50px;" v-for="item in AllKPIInfo" :key="item.sysUser.Id" > 
      <div style="margin-top:20px;background-color: #f0f2f2;padding-top: 10px;padding-bottom: 15px;" class="viewKPITitle">
        <el-row style="margin-top:10px;text-align:center;">{{item.sysUser.MainDeptsName}} KPI考核表</el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="6">
            被考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.sysUser.TrueName}}</span>
          </el-col>
          <el-col :span="6">
            被考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.sysUser.Duty}}</span>
          </el-col>
          <el-col :span="6">
            被考核者工号：<span v-if="AllKPIInfo.length>0">{{item.sysUser.UserCode}}</span>
          </el-col>
          <el-col :span="6">
            考核周期：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].Period}}{{item.userKPI[0].PeriodType==0?'月':'季度'}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="6">
            考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadTrueName}}</span>
          </el-col>
          <el-col :span="6">
            <!-- {{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}}-->
            考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadDuty}}</span>
          </el-col>
        </el-row>
      </div>
      <!-- 考核列表信息  show-summary :summary-method="getSummaries"-->
      <el-table border show-summary :summary-method="getSummaries" :data="item.userKPI" style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
          <el-table-column  min-width="10" prop="KPI"  label="KPI名称"></el-table-column>
          <el-table-column prop="Explain" min-width="18" label="指标说明"></el-table-column>
          <el-table-column prop="Contents" min-width="24" label="考核细则"></el-table-column>
          <el-table-column  min-width="18" label="KPI类型">
              <template slot-scope="scope">
                  {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
              </template>
          </el-table-column>
          <el-table-column  min-width="18" label="周期">
              <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
          </el-table-column>
          <el-table-column  min-width="18" prop="KPIWeight" label="KPI权重"></el-table-column>
          <el-table-column prop="Execution" min-width="18" label="完成情况"></el-table-column>
          <el-table-column prop="SelfScore" min-width="10" label="自评评分">
              <template slot-scope="scope">
                  {{scope.row.Status == 0 ?'':scope.row.SelfScore}}
              </template>
          </el-table-column>
          <el-table-column prop="LeadScore" min-width="10" label="直属领导评分">
              <template slot-scope="scope">
                  {{scope.row.LeadStatus == 0 ?'':scope.row.LeadScore}}
                  <!-- <el-button type="primary" v-if="(scope.row.KPIResultstatus===0||scope.row.KPIResultstatus===2||scope.row.KPIResultstatus===5)  && (scope.row.KPIType!==1)" @click="LeadScore(scope.row)" plain size="mini">评分</el-button> -->
              </template>
          </el-table-column>
      </el-table>
    </div>
    
    <el-row>
      <el-col :span="24">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetNeedMyScoreKPI,UpdateLeadScore,GetMyKPIScore } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
  props: {
    pt: {
      Type: Number
    },
    activeName:{
      Type:String
    }
  },
  data(){
    return{
      pType: this.pt,
      loading:true,
      userinfo:{},
      userCode:'',//被考核者工号
      AllKPIInfo:{},
      searchName:'',//搜索条件
      yearValue:'',//季度选择年
      year:'',//选择年
      month:'',//选择月
      dateMonth:'',//当前选择月份
      dateJidu:'',//季度
      dialogFormVisible:false,//弹框是否显示
      formLabelWidth:'120px',
      // SelfScoreModel:{
      //     Id:'',//当前kpi id
      //     LeadScore:0,//自评分数
      //     Execution:'',//完成情况
      // },
      //分页信息
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
    }
  },
  created() {
    //获取当前登录用户信息
    this.GetUserinfo();
    
    var date=new Date();
    this.year=date.getFullYear();
    this.month=date.getMonth()+1;
    // if(this.month==12){
    //     //如果上个月是12月，则年份减1为上个月
    //     this.year=this.year-1;
    // }

    //获取上个季度数据
    if(this.pType==1){
      this.month=this.month+1;
      //季度时 选择当前季度
      if(this.month>=1&&this.month<=3){
        this.month='Q1';
      }
      else if(this.month>=4&&this.month<=6){
        this.month='Q2';
      }
      else if(this.month>=7&&this.month<=9){
        this.month='Q3';
      }
      else{
        this.month='Q4';
      }
    }
    //获取我的KPI
    this.GetNeedMyScoreKPI();
  },
  methods: {
    Refresh:function(){
      this.GetNeedMyScoreKPI();
    },
    //条件搜索
    SearchByName:function(){
      if(this.dateMonth||(this.dateJidu&&this.yearValue)){
        if(this.pType==0){
          //获取的年月需要转换
          this.year=this.dateMonth.getFullYear();
          this.month=this.dateMonth.getMonth()+1;           
        }
        else{
          //季度直接使用 
          this.month=this.dateJidu;
          this.year=this.yearValue.getFullYear();
        }
      }
      //获取我的KPI
      this.GetNeedMyScoreKPI();
      if(this.totalCount==0){
        this.$message({
            message: '暂无数据',
            type: 'success'
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetNeedMyScoreKPI();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetNeedMyScoreKPI();
    },
    //获取当前登录用户信息
    GetUserinfo:function(){
      this.userinfo=GetCurrentUserInfo();
      this.userCode=this.userinfo.UserCode;
    },
    //获取需我评分的KPI
    GetNeedMyScoreKPI:async function(year,month){
      await GetNeedMyScoreKPI(this.userinfo.UserCode,this.pType,this.month,this.year,this.pageIndex,this.pageSize,this.searchName).then(res=>{
        this.loading=false;
        this.AllKPIInfo=res.DataList;
        this.totalCount = res.TotalCount;
        // this.userList=res;
      });
    },
    //获取合计列
    getSummaries:function(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = '合计';
              return;
          }
          else if(index === 1){
              //第七列 自评分数合计
              var quanzhong=0;
              param.data.forEach((column, index) => {
                  quanzhong+=column.KPIWeight;
              })
              sums[index]=quanzhong;
          }
          else if(index === 7){
              //第七列 自评分数合计
              var SelfScoreAll=0;
              param.data.forEach((column, index) => {
                  SelfScoreAll+=column.SelfScore;
              })
              sums[index]='自评总分：'+SelfScoreAll.toFixed(2);
          }
          else if(index===8){
              //第八列 领导评分合计
              var leadScoreAll=0;
              param.data.forEach((column, index) => {
                  leadScoreAll+=column.LeadScore;
              })
              sums[index]='领导评分：'+leadScoreAll.toFixed(2);
          }
          
      });
      return sums;
    }
  }
}
</script>
<style lang="less" scoped>
.viewKPITitle {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
.show{
  display: block;
}
.hidden{
  display: none;;
}
.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
  color:red !important;
}
</style>